<template>
  <div id="page" ref="homePage" class="page">
    <div class="main">
      <div class="content-box">
        <div class="result-title">本次需支付</div>
        <div class="result-text">¥<span class="money">{{ goodsData.prices }}</span></div>
      </div>
      <div class="content-hint">
        <div class="big">本次支付订单信息</div>
        <!--        <div class="order-item">-->
        <!--          <div>支付单号</div>-->
        <!--          <div class="small-text">{{ order_sn }}</div>-->
        <!--        </div>-->
        <div v-if="goodsData.is_show == 1 || goodsData.is_show == 0" class="order-item">
          <div>支付时间</div>
          <div>剩余<span class="color-reb">{{ countDown }}</span>自动关闭</div>
        </div>
        <div class="order-item">
          <div>对应项目</div>
          <div>{{ goodsData.spec_name }}</div>
        </div>
        <div class="order-item">
          <div>支付金额</div>
          <div>￥{{ goodsData.payprice }}</div>
        </div>
        <div class="big">请选择支付方式</div>
        <div class="pay-box">
          <van-radio-group v-model="payType" icon-size="18px" checked-color="#FF4713">
            <van-radio v-if="isWx" :name="1" :class="['pay-item', payType == 1 ? 'sel' : '']" label-position="left">
              <div class="pay-left">
                <img src="../images/icon-wx.png" class="icon-type">
                <span class="pay-name">微信支付</span>
              </div>
            </van-radio>
            <van-radio :name="2" :class="['pay-item', payType == 2 ? 'sel' : '']" label-position="left">
              <div class="pay-left">
                <img src="../images/icon-ali.png" class="icon-type">
                <span class="pay-name">支付宝支付</span>
              </div>
            </van-radio>
          </van-radio-group>
        </div>
      </div>
      <div class="bottom-slogan" />
    </div>
    <div class="submit-btn" @click="onSubmit">马上支付</div>
    <!-- 支付成功弹窗 -->
    <van-popup v-model="payPopup" position="center" :close-on-click-overlay="false">
      <div class="pay_box">
        <van-button class="pay_btn" type="info" @click="finishPay">我已完成支付</van-button>
        <van-button class="pay_btn" type="info" plain @click="closePay">支付遇到问题</van-button>
      </div>
    </van-popup>
    <!-- 浏览器打开 -->
    <van-popup v-model="hintPopup" position="top">
      <img v-if="isEnv == 'android'" class="hint-img" src="../images/android.png">
      <img v-if="isEnv == 'ios'" class="hint-img" src="../images/ios.png">
      <div v-if="showPay" class="pay_box none">
        <van-button class="pay_btn" type="info" @click="finishPay">我已完成支付</van-button>
        <van-button class="pay_btn" type="info" plain @click="closePay">支付遇到问题</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { RadioGroup, Radio, Toast, Dialog, Popup, Button, SubmitBar } from 'vant'
import wx from 'weixin-js-sdk'
import { checkOrder, checkAliOrder } from '@/api/apply'
import { getLogin } from '@/utils/auth' // 获取auth参数
// import { checkUserOrder } from '@/api/purchase'
import { checkUserOrder, userPay } from '@/api/purchase'
import { getUrlKey, checkWx, parseTime, timeRegroup } from '@/utils/index'

export default {
  name: 'AliPay',
  components: {
    [SubmitBar.name]: SubmitBar,
    [Button.name]: Button,
    [Popup.name]: Popup,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio
  },
  filters: {},
  data: function() {
    return {
      isWx: true,
      isEnv: 'ios', // 环境
      goodsData: {}, // 商品信息
      setTime: null, // 倒计时
      countDown: null, // 倒计时
      // 支付
      isPayLoading: false,
      environment: 1, // 支付环境 1：web环境、2：微信环境、3：PC端微信扫码支付、4：支付宝环境、5：非支付宝
      pay_state: false, // 支付状态
      order_sn: null,
      trade_no: undefined, // 支付订单号
      pay_count: 10, // 支付次数
      payPopup: false, // 支付后弹出的窗口
      // 选择支付方式
      payType: 1,
      hintPopup: false,
      showPay: false
    }
  },
  created() {
    const that = this
    setTimeout(function() {
      that.winH = document.documentElement.clientHeight || document.body.clientHeight
      that.$refs.homePage.style.minHeight = that.winH + 'px'
    }, 300)
    // 非微信环境查询, 弹出订单是否支付完成
    var order_sn = this.$route.query.order_sn || getUrlKey('order_sn') || sessionStorage.getItem('interview_pay_order_sn',)
    var trade_no = this.$route.query.trade_no || getUrlKey('trade_no') || sessionStorage.getItem('interview_pay_trade_no')
    var pay_code = this.$route.query.pay_code || getUrlKey('pay_code') || sessionStorage.getItem('interview_pay_trade_code')
    if (order_sn && trade_no && pay_code) {
      this.order_sn = order_sn
      this.trade_no = trade_no
      this.pay_code = pay_code
      this.isWx = checkWx()
      this.checkUserOrder()
      if (!checkWx()) {
        this.payType = 2
        if (sessionStorage.getItem('interview_showCheck')) { // 弹出支付窗口
          this.payPopup = true
        }
      }
    } else {
      this.$sentry.captureMessage('orderPay', { level: 'info', tags: 'orderPay', extra: { context: '获取订单失败' }})
    }
  },
  destroyed() {
    clearInterval(this.setTime)
  },
  methods: {
    // 查询用户订单
    checkUserOrder() {
      var that = this
      checkUserOrder({
        open_id: getLogin(),
        'ordersn': this.order_sn
      }).then(res => {
        console.log(res.data.data.list[this.order_sn])
        if (res.data.code === 200 && res.data.data.list[this.order_sn]) {
          var data = res.data.data.list[this.order_sn][0]
          if (data.is_show === 1 || data.is_show === 0) { // 待支付
            // 处理剩余支付时间
            const times = data.creatdate.replace(/-/g, '/')
            const endTime = new Date(times)
            const addTime = parseTime(endTime.setDate(endTime.getDate() + 2))
            that.countDown = timeRegroup(addTime)
            if (!that.countDown) {
              data.is_show = 7
            } else {
              this.setTime = setInterval(() => {
                that.countDown = timeRegroup(addTime)
                if (!that.countDown) {
                  clearInterval(that.setTime)
                  that.$set(that.goodsData, 'is_show', 7)
                }
              }, 1000)
            }
          } else if (data.is_show === 2 || data.is_show === 3 || data.is_show === 4 || data.is_show === 5 || data.is_show === 6) {
            Dialog.alert({
              title: '温馨提示',
              message: '系统检测：此商品您已支付'
            }).then(() => {
              that.$router.replace('/')
            })
          } else if (data.is_show === 7 || data.is_show === -1) { // 已取消
            Dialog.alert({
              title: '温馨提示',
              message: '系统检测您有一笔订单已失效，请重新提交'
            }).then(() => {
              that.$router.replace('/') // 无订单、返回上一层
            })
          }
          data.prices = parseFloat(data.prices)
          this.goodsData = data
          console.log(this.goodsData)
          Toast.clear()
        } else {
          this.$sentry.captureMessage('orderPay', { level: 'info', tags: 'checkUserOrder', extra: { context: '未查询到用户的订单' + this.order_sn }})
          Toast.clear()
          Dialog.alert({
            title: '系统提示',
            message: '系统检测到该订单号错误，请截图后联系小助手：' + this.order_sn
          }).then(() => {
            sessionStorage.removeItem('interview_pay_order_sn')
            sessionStorage.removeItem('interview_pay_trade_no')
            that.$router.replace('/')
          })
        }
      })
    },
    // 确认支付方式
    onSubmit() {
      if (this.isWx) { // 选择支付宝 and 微信环境
        if (this.payType === 2) {
          this.showPay = false
          setTimeout(() => {
            this.showPay = true
          }, 10000)
          this.hintPopup = true
        } else {
          this.environment = 2
          this.checkUserStatus()
        }
      } else { // 非微信
        this.environment = this.payType === 2 ? 4 : 1 // 非支付宝 or web环境
        this.checkUserStatus()
      }
    },
    // 创建支付订单
    checkUserStatus() {
      // 确认支付状态，防止重复提交订单
      if (this.goodsData.is_show === 1 || this.goodsData.is_show === 0) { // 待支付
        var url = window.location.origin + window.location.pathname + window.location.search + '#/paySucceed?orderId=' + this.order_sn + '&type=' + this.payType
        console.log('url', url)
        userPay({
          open_id: getLogin(),
          ordersn: this.order_sn,
          payway: this.payType,
          environment: this.environment,
          activity_pay: this.pay_code,
          // notifyUrl: url,
          channel: getUrlKey('income'),
          return_url: url + '&payType=aliPay' // 添加?, 避免支付回调返回&
        }).then(res => {
          console.log(res.data)
          if (res.data.code === 200) {
            this.trade_no = res.data.data.trade_no
            if (checkWx()) {
              this.openConfig(res.data.data)
            } else {
              // 将订单添加进入缓存(留着查询)
              sessionStorage.setItem('interview_pay_order_sn', this.order_sn)
              sessionStorage.setItem('interview_pay_trade_no', res.data.data.trade_no)
              if (this.payType === 2) {
                this.payPopup = true
                sessionStorage.setItem('interview_showCheck', true)
              }
              // 添加回调地址
              var url = window.location.origin + window.location.pathname + window.location.search + '#/paySucceed?orderId=' + this.order_sn + '&type=' + this.payType
              window.location.href = this.payType === 2 ? res.data.data.pay_url : res.data.data.pay_url + '&redirect_uri=' + url
            }
          } else {
            this.$sentry.captureMessage('orderPay', { level: 'error', tags: 'userPay', extra: { context: '支付失败' }})
            Toast.fail(res.data.data)
          }
        })
      }
    },
    // 确认订单支付成功
    checkOrder() {
      if (parseInt(this.payType) === 2) {
        checkAliOrder({
          order_sn: this.order_sn,
          trade_no: this.trade_no
        }).then(res => {
          console.log('进入订单确认接口')
          if (res.data.code === 200) {
            Toast.success('支付成功')
            this.closePay()
            this.isPayLoading = false
            this.payPopup = false
            this.$router.replace('/paySucceed?orderId=' + this.order_sn + '&type=' + this.payType)
          } else {
            // 如果失败，轮训请求
            if (this.pay_count >= 0) {
              this.pay_count = this.pay_count - 1
              this.checkOrder()
            } else {
              // 支付失败，清除缓存
              Dialog.alert({
                title: '支付提示',
                message: '支付失败，请重试'
              }).then(() => {
                this.closePay()
              })
            }
          }
        })
      } else {
        checkOrder({
          order_sn: this.order_sn,
          trade_no: this.trade_no
        }).then(res => {
          console.log('进入订单确认接口')
          if (res.data.code === 200) {
            Toast.success('支付成功')
            this.closePay()
            this.isPayLoading = false
            this.payPopup = false
            this.$router.replace('/paySucceed?orderId=' + this.order_sn + '&type=' + this.payType)
          } else {
            // 如果失败，轮训请求
            if (this.pay_count >= 0) {
              this.pay_count = this.pay_count - 1
              this.checkOrder()
            } else {
              // 支付失败，清除缓存
              Dialog.alert({
                title: '支付提示',
                message: '支付失败，请重试'
              }).then(() => {
                this.closePay()
              })
            }
          }
        })
      }
    },
    // 打开微信config
    openConfig(data) {
      var that = this
      console.log('进入config', data)
      wx.config({
        debug: false,
        appId: data.appid, // 必填，公众号的唯一标识
        timestamp: data.timestamp, // 必填，生成签名的时间戳
        nonceStr: data.noncestr, // 必填，生成签名的随机串
        signature: data.signature, // 必填，签名
        jsApiList: ['chooseWXPay']
      })
      wx.ready(() => {
        wx.checkJsApi({
          jsApiList: ['chooseWXPay'],
          success: res => {
            that.openWxPay(data)
            console.log('checked api:', res)
          },
          fail: err => {
            that.isPayLoading = false
            this.$sentry.captureMessage('orderPay', { level: 'error', tags: 'openWxConfig', extra: { context: err }})
            console.log('check api fail:', err)
          }
        })
      })
    },
    // 打开微信支付
    openWxPay(data) {
      var that = this
      console.log('进入chooseWXPay', that, data)
      wx.chooseWXPay({
        'appId': data.appid,
        'timestamp': data.timeStamp,
        'nonceStr': data.nonce_str,
        'package': data.package,
        'signType': data.signType,
        'paySign': data.sign,
        success: res => {
          this.checkOrder() // 确认订单支付状态
        },
        cancel: res => {
          that.isPayLoading = false
          Toast.fail('支付失败')
          console.log(res)
        }
      })
    },
    // 点击我已完成支付
    finishPay() {
      Toast.loading('查询支付状态中..')
      this.checkOrder()
    },
    // 点击关闭，清空
    closePay() {
      console.log('清空')
      this.pay_count = 5
      this.pay_state = false
      this.isPayLoading = false
      this.showPay = false
      this.hintPopup = false
      this.payPopup = false
      sessionStorage.setItem('interview_showCheck', false)
      Toast.clear()
    }
  }
}
</script>

<style lang="less" scoped>
  .page{
    position: relative;
    width: 375px;
    padding-top: 20px;
    .banner{
      position: absolute;
      width: 100%;
      top: 0;
      left: 0;
    }
  }
  .main{
    position: relative;
    top: 0;
    z-index: 1;
    width: 340px;
    margin: 0 auto 10px auto;
    padding-bottom: 50px;
    .content-box{
      position: relative;
      border-radius: 15px 15px 0 0;
      background: #fff;
      padding: 30px 25px 0 25px;
      z-index: 2;
      color: #191919;
      text-align: center;
      .result-title{
        font-size: 15px;
        margin-bottom: 10px;
      }
      .result-text{
        border-bottom: 1px solid #666;
        font-weight: bold;
        font-size: 25px;
        padding-bottom: 12px;
        .money{
          font-size: 44px;
          color: #191919;
        }
      }
    }
    .content-hint{
      position: relative;
      z-index: 1;
      padding: 10px 25px 20px 25px;
      border-radius: 0 0 15px 15px;
      background: #fff;
      line-height: 22px;
      font-size: 14px;
      .big{
        position: relative;
        display: inline-block;
        padding-bottom: 5px;
        color: #333;
        font-weight: bold;
        padding-top: 30px;
        &:after{
          position: absolute;
          top: 20px;
          left: 0;
          content: '';
          width: 12px;
          height: 2px;
          background: #ee5030;
          z-index: 1;
        }
      }
      .order-item{
        background: #ececec;
        font-size: 15px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 4px 8px;
        margin: 8px 0;
        .small-text{
          font-size: 12px;
        }
      }
    }
    .pay-box{
      border-top: 1px solid #666;
      .pay-item{
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 15px;
        padding: 0 6px;
        .pay-left{
          padding: 12px 0;
          width: 200px;
          display: flex;
          align-items: center;
        }
        .icon-type{
          width: 23px;
          height: 21px;
          margin-right: 12px;
          display: inline-block;
        }
      }
    }
    .bottom-slogan{
      border-radius: 0 0 15px 0;
      background: #fff;
      width: 50%;
      height: 25px;
      margin-left: 50%;
      padding-bottom: 10px;
      position: relative;
      top: -15px;
      &:before{
        content: '';
        font-size:0;
        border-style:solid;
        overflow:hidden;
        position:absolute;
        border-width:46px;
        border-color: transparent #fff transparent transparent;
        left:-92px;
        bottom:0;
      }
      .slogan-path{
        position: absolute;
        left: -50px;
        top: -15px;
        width: 200px;
        height: 100px;
        background: url("../images/slogan.png") no-repeat left center;
        background-size: 100%;
        z-index: 1;
      }
    }
  }
  .pay_box{
    width: 240px;
    text-align: center;
    background: #fff;
    padding: 20px 0;
    margin: 0 auto;
    &.pay_box{
      background: none;
      .pay_btn{
        width: 240px;
        margin: 30px auto;
        display: block;
      }
    }
    .pay_btn{
      width: 200px;
      margin: 20px auto;
      display: block;
    }
  }
  .hint-img{
    width: 80%;
    margin-left: 20%;
  }
  .van-popup{
    background: none;
  }
  .submit-btn{
    z-index: 99;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 50px;
    font-size: 16px;
    text-align: center;
    color: #fff;
    background: #ee5030;
    line-height: 50px;
  }
  .color-reb{
    color: #ee5030;
  }
</style>
